import { useEffect } from "react";
import { resolveCase } from "../case/registry";
import { modulesFor } from "../modules/registry";
import { AppIcon, IconAgencia } from "../ui/icons";
import styles from "./shell.module.css";

/**
 * Instalación diegética de módulos (F1-T07, os §3): "La Agencia habilitó: …".
 * Un ícono nuevo en el escritorio es una promesa de contenido — este splash
 * es el redoble. Auto-avanza a los 2.6 s; clic salta.
 */

export function ModulesInstall({ caseId, onDone }: { caseId: string; onDone: () => void }) {
  const mods = modulesFor(resolveCase(caseId));

  useEffect(() => {
    const t = window.setTimeout(onDone, 2600);
    return () => window.clearTimeout(t);
  }, [onDone]);

  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: pantalla transitoria unipropósito — cualquier clic salta
    // biome-ignore lint/a11y/useKeyWithClickEvents: ídem
    <div className={styles.installScreen} onClick={onDone} data-testid="modules-install">
      <span className={styles.installCrest}>
        <IconAgencia size={44} />
      </span>
      <p className={styles.installTitle}>La Agencia habilitó para este expediente:</p>
      <div className={styles.installList}>
        {mods.map((m, i) => (
          <div key={m.id} className={styles.installItem} style={{ animationDelay: `${i * 0.5}s` }}>
            <span className={styles.installIcon}>
              <AppIcon appId={m.id} size={30} />
            </span>
            <span className={styles.installName}>{m.title}</span>
          </div>
        ))}
      </div>
      <p className={styles.installHint}>clic para continuar</p>
    </div>
  );
}
